import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { MapIcon } from '@svgs'
import { Button } from 'src/components/ui'

// A mistyped or outdated address used to bounce silently to the map, so a
// broken link looked like the site ignoring the click. Now it says so and
// offers the way back.
export default function NotFoundPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <section
      className="flex flex-col items-center justify-center gap-4 min-h-[50vh] px-4 py-12 text-center text-ink"
      data-testid="not-found"
    >
      <span className="text-6xl font-black text-brand leading-none">404</span>
      <h1 className="m-0 text-[1.75rem] font-black leading-[2.125rem]">
        {t('not_found_page.title')}
      </h1>
      <p className="m-0 max-w-md text-base leading-6 text-ink-2">{t('not_found_page.text')}</p>
      <div className="flex flex-wrap justify-center gap-3 mt-2">
        <Button link="/" iconAfter={<MapIcon />}>
          {t('not_found_page.to_map')}
        </Button>
        <Button variant="outlined" onClick={() => navigate(-1)}>
          {t('not_found_page.back')}
        </Button>
      </div>
    </section>
  )
}
